<template>
  <div class="flex overflow-hidden">
    <span
      v-for="(user, index) in filteredUsers"
      :key="user.id"
      :class="`${
        index ? '-ml-4' : ''
      } inline-block rounded-full text-white shadow-solid`"
    >
      <thumbnail
        size="28px"
        :username="user.name"
        :src="user.avatar"
        has-border
      />
    </span>
  </div>
</template>

<script>
import Thumbnail from 'dashboard/components/widgets/Thumbnail.vue';

export default {
  name: 'GroupedAvatars',
  components: { Thumbnail },
  props: {
    users: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    filteredUsers() {
      let filUsers = {};
      return this.users.filter(
        (user) => !filUsers[user.id] && (filUsers[user.id] = true)
      );
    },
  },
};
</script>
